export default function FullWidthVisualCloser() {
  return <section id="fullwidthvisualcloser" className="w-full bg-background p-0 m-0">
      <div className="w-full bg-muted flex flex-col items-center justify-center">
        {}
      </div>
    </section>;
}